import React,{ useState,useEffect, useRef} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import {connect} from 'react-redux';
import swal from 'sweetalert';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Autocomplete from '@material-ui/lab/Autocomplete';
import MUIDataTable from "mui-datatables";
import {API_URL} from '../../config.json';
import {BrowserRouter as Router,Route,Link} from 'react-router-dom'
import axios from 'axios';
import SaveIcon from '@material-ui/icons/Save';
import Button from '@material-ui/core/Button';
import CheckIcon from '@mui/icons-material/Check';


import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import AsyncSelect from 'react-select/async';

import EditIcon from '@material-ui/icons/Edit';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import DateFnsUtils from '@date-io/date-fns';

import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
  } from '@material-ui/pickers';

import DeleteIcon from '@material-ui/icons/Delete';
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';



import Stack from '@mui/material/Stack';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DesktopDatePicker from '@mui/lab/DesktopDatePicker';




import {currentRouteSet} from '../../actions/actions';

import {pathSpliter,checkAuthBranchWare,dateTimeFormat,currentDateTime,dateFormat} from '../../lib/functions'
import moment from 'moment';


import _ from 'lodash';
import commaNumber from 'comma-number';
let format = commaNumber.bindWith(',', '.')

const GroupManage = ({location,currentRouteSet,currentRoute,authInfo})=>{
    const classes = useStyles();
 
  useEffect(()=>{
    getRecognitions();
    currentRouteSet(pathSpliter(location.pathname,1));
  },[])

    // Init states start
 
    
    let [Recognition_id,Recognition_id_set] = useState(0)
    let [Recognitions,RecognitionsSet] = useState([])
    let [recognitionCart,recognitionCartSet] = useState([])
    let [loadFromAccounts,loadFromAccountsSet] = useState([])
    let [loadToAccounts,loadToAccountsSet] = useState([])
    
    let [loadingList,loadingListSet] = useState(false)
    let [loadingSave,loadingSaveSet] = useState(false)

    let [action,action_set] = useState('create');
    let [Recognition_code,Recognition_code_set] = useState('');
    let [Recognition_ind_id,Recognition_ind_id_set] = useState(null);

    let [narration,narration_set] = useState('');
    let [description,description_set] = useState('');
    let [remark,remark_set] = useState('');

    

    let [amount,amount_set] = useState('');
    
    
    const [RecognitionDate, RecognitionDateSet] = useState(currentDateTime);
    const [selectedAccountFrom, selectedAccountFromSet] = useState(null);
    const [selectedAccountInto, selectedAccountIntoSet] = useState(null);

    let code_ref = useRef(null)
    let acc_from_ref = useRef(null)
    let acc_into_ref = useRef(null)
    let amount_ref = useRef(null)
    let Recognition_date_ref = useRef(null)
    let narration_ref = useRef(null)
    let remark_ref = useRef(null)


  
  useEffect(()=>{
    getRecognitions()
  },[RecognitionDate])

   
    const RecognitionDateChange = (date) => {
        RecognitionDateSet(date);
      };


    
    const getRecognitions = async ()=>{
        await axios.post(`${API_URL}/api/get-recognition-with-details`,{oneDate:RecognitionDate},{headers:{'auth-token':authInfo.token}}).then(res=>{
        RecognitionsSet(res.data)
      })
    }


    
    const [account_name_from, account_name_from_set] = useState("");
    const [account_name_to, account_name_to_set] = useState("");

    useEffect(()=>{
      getLoadFromAccounts()
    },[account_name_from]);

    useEffect(()=>{
      getLoadToAccounts()
    },[account_name_to]);

    const getLoadFromAccounts = async() => {
      return  await axios.post(`${API_URL}/api/get-accounts-by-search`,{query:account_name_from,search:true,type:'indirect_Recognition'},{headers:{'auth-token':authInfo.token}}).then(res=>{
        loadFromAccountsSet(res.data)
        })
    };

    const getLoadToAccounts = async() => {
      return  await axios.post(`${API_URL}/api/get-accounts-by-search`,{query:account_name_to,search:true,multiType:['cash_in_hand','bank_account']},{headers:{'auth-token':authInfo.token}}).then(res=>{
        loadToAccountsSet(res.data)
        })
    };



  



    // Init states end
    // Methods script start
    const saveFormAction = async ()=>{

            let totalRecognition = _.sumBy(recognitionCart,(tran)=>parseFloat(tran.amount))

            if(recognitionCart.length == 0){
              swal({
                title:`Recognition Cart is Empty.`,
                icon:'warning'
              });
              return false
            }else{
            let payLoad = {
              recognition:{
                creation_date:RecognitionDate,
                total_amount:totalRecognition,
                narration,
                recog_id:Recognition_id,
                action
              },
              recognitionDetail:recognitionCart
            }
            loadingSaveSet(true);
            await axios.post(`${API_URL}/api/save-recognition`,{  
              ...payLoad
            },{headers:{'auth-token': authInfo.token}}).then(res=>{
              loadingSaveSet(false);
             if(res.data.error == false){
               swal({
                 title: res.data.msg,
                 icon:'success'
               })
               RecognitionDateSet(currentDateTime)
               recognitionCartSet([])
               action_set('create')
               narration_set('')
               Recognition_id_set(0)
               getRecognitions()
               selectedAccountIntoSet(null)

             }else{
              swal({
                title: res.data.msg,
                icon:'warning'
              })
             }
            });

            }
         
            
          
          
    }


  const removeRecognitionTran = (sl)=>{
    let preCopy =  [...recognitionCart];
    preCopy.splice(sl, 1);
    recognitionCartSet(preCopy)

  }

  const addTORecognition = ()=>{

    if((amount == 0 || amount == '')){
      swal({
        title:`Recognition Amount  cannot be 0.`,
        icon:'warning'
      });
      return false
    }else{

      let tran = {
        description : description,
        remark : remark,
        amount : amount =='' ? 0 :amount
      }
      if(Recognition_ind_id == null){
        recognitionCartSet([...recognitionCart,tran])
      }else{
        let preCopy =  [...recognitionCart];
        preCopy[Recognition_ind_id] = tran
        recognitionCartSet(preCopy)

      }


      Recognition_ind_id_set(null)
      description_set('')
      remark_set('')
      amount_set('')
      
     }

    
     

   
    }



    const approveAction = async (row)=>{
        swal({
          title:'Are you sure approve this?',
          icon:'warning',
          buttons:true
        }).then(async(yes)=>{
          if(yes){
            let payment =  Recognitions.filter((payment)=>payment.recog_id == row[0])
            await axios.post(`${API_URL}/api/approve-expense-recognition`,{recog_id:payment[0].recog_id},
            {headers:{'auth-token':authInfo.token}}).then(res=>{
                    getRecognitions();
                    swal({
                      title: res.data.msg,
                      icon:'success'
                    })
                    
                  })
          }else{
            return false
          }
        })
        
  
            }

            


    // Methods script end
    const ActionOptions = (props)=>{
      return(<div style={{textAlign:'right'}}> 

      

{
        authInfo.role =='super_admin' && props.rowData[1] == 'p'?(<>
                <CheckIcon style={{cursor:'pointer',fontSize: '28px',color: 'rgb(15, 126, 119)'}} onClick={()=>approveAction(props.rowData)}/>
        </>):''
      }




{
    authInfo.role !='user'?(
    <>
        <EditIcon style={{cursor:'pointer',fontSize: '28px',color: 'rgb(15, 126, 119)'}} onClick={()=>RecognitionEdit(props.rowData)}/>
      
        <DeleteIcon style={{cursor:'pointer',color: '#ff0202',fontSize: '28px'}} onClick={()=>RecognitionDelete(props.rowData)}/>
            
   </>):''
 }
      {
        props.rowData[1] == 'p' ? 'Pending' :'Approved'
      }


      </div>)
    
    }


    const RecognitionEdit = (row,index)=>{
      let Recognition =  Recognitions.filter((Recognition)=>Recognition.recog_id == row[0])
      Recognition = Recognition[0]
      recognitionCartSet(Recognition.details)

      Recognition_id_set(Recognition.recog_id)
      action_set('update')
      
      RecognitionDateSet(Recognition.creation_date)
      narration_set(Recognition.narration)
     
    }


    const editRecognitionTran = (row,sl)=>{
      Recognition_ind_id_set(sl)
      amount_set(row.amount)
      description_set(row.description)
      remark_set(row.remark)
    }


    const RecognitionDelete = async (row)=>{
      swal({
        title:'Are you sure delete this?',
        icon:'warning',
        buttons:true
      }).then(async(yes)=>{
        if(yes){
          let Recognition =  Recognitions.filter((Recognition)=>Recognition.recog_id == row[0])
          await axios.post(`${API_URL}/api/delete-recognition`,{recog_id:Recognition[0].recog_id},
          {headers:{'auth-token':authInfo.token}}).then(res=>{
                  getRecognitions();
                  swal({
                    title: res.data.msg,
                    icon:'success'
                  })
                  
                })
        }else{
          return false
        }
      })
      

          }
   
    const columns = [
      {name: "recog_id",options: { display: 'excluded' }},
      {name: "status",options: { display: 'excluded' }},
      {name:"SL",options: {filter: false,sort: false,
        customBodyRender:(value,tableMeta)=>{
        return ( <p>{parseFloat(tableMeta.rowIndex)+1}</p> ); 
      }
      },headerStyle: {
        textAlign:'left'
      }},
      {name: "creation_date",label: "Recognition Date",options: {filter: true,sort: true,
        customBodyRender:(value,tableMeta)=>{
          return(<p>{ moment(tableMeta.rowData[3]).format(dateFormat) }</p>) 
        }
      }},
      {name: "total_amount",label: "Recognition Total",options: {filter: true,sort: true}},
      {name: "narration",label: "Narration",options: {filter: true,sort: true}},
      {name: "user_full_name",label: "Created By",options: {filter: true,sort: true}},


      {name:"actions",options: {filter: false,sort: false,
        customBodyRender:(value,tableMeta)=>{
          return ( <ActionOptions   value={value} rowIndex={tableMeta.rowIndex}  rowData={tableMeta.rowData} 
             /> ); 
      }
      },headerStyle: {
        textAlign:'right'
      }}
     ];
            
     const options = {
       filterType: 'checkbox',
       selectableRows: 'none',
       display: "excluded"
      }


    return (
    <div className={classes.root}>

     <Paper className={classes.paper} style={{marginTop:'-15px'}}>
    <h2 className={classes.pageEntryLabel}>Expense Recognition Entry </h2>
      <Grid container spacing={2}>
      <Grid item xs={12} sm={4}>
 


     


<Grid item xs={12} sm={12}>



     <TextField type="text"  
         onKeyDown={event => {
           if (event.key === "Enter") {
            amount_ref.current.focus()
           }
         }} autoComplete='off' className={classes.fullWidth} 
        label="descriptionription" name="description" value={description} 
        variant="outlined" size="small" onChange={(e)=>{

                    description_set(e.target.value)
                
           
            }} />

      

</Grid>

<br/>
        <Grid item xs={12} sm={12}> 
        <TextField type="number"  
         inputRef={amount_ref}
         onKeyDown={event => {
           if (event.key === "Enter") {
            remark_ref.current.focus()
           }
         }} autoComplete='off' className={classes.fullWidth} 
        label=" Amount" name="amount" value={amount} 
        variant="outlined" size="small" onChange={(e)=>{

                    amount_set(e.target.value)
                
           
            }} />


        </Grid>
        <br/>


        <Grid item xs={12} sm={12}>



     <TextField type="text"  
              inputRef={remark_ref}

         onKeyDown={event => {
           if (event.key === "Enter") {
            addTORecognition()
           }
         }} autoComplete='off' className={classes.fullWidth} 
        label="Remarmk" name="remark" value={remark} 
        variant="outlined" size="small" onChange={(e)=>{

            remark_set(e.target.value)
                
           
            }} />

      

</Grid>

<span>Press Enter Key to Recognition </span>

<br/>



        


        <Grid item xs={12} sm={6} style={{marginTop: '20px'}}>
           <Button onClick={()=>addTORecognition()} style={{background: 'rgb(109 113 113)',color: 'white',fontSize: '10px'}}>Add To Recognition</Button>
        </Grid>


      </Grid>

      <Grid item xs={12} sm={8}>

        <Grid item xs={12} sm={12}>


            <Grid item xs={12} sm={5} style={{float:'left',width: '100%'}}>
     




            </Grid>


            <Grid item xs={12} sm={3} style={{float:'right',marginTop: '-8px',marginLeft:'5px'}}> 
      
            
            <LocalizationProvider dateAdapter={AdapterDateFns} style={{marginTop: '0px'}}>
        <Stack spacing={3}>
          <DesktopDatePicker
            label="Recognition Date" 
            inputFormat={dateTimeFormat}
            inputRef={Recognition_date_ref}
           
            value={RecognitionDate}
            onChange={(e)=>RecognitionDateChange(e)}
            renderInput={(params) => <TextField 
              onKeyDown={event => {
                if (event.key === "Enter") {
                    narration_ref.current.focus()
                }
            }}
            
              {...params} />}
          />
          
        </Stack>
        </LocalizationProvider>


        </Grid>


        <Grid item xs={12} sm={3} style={{float:'right',marginTop: '0px'}}> 
        {/* <TextField  autoComplete='off' className={classes.fullWidth} 
        inputRef={code_ref}
        onKeyDown={event => {
            if (event.key === "Enter") {
              Recognition_date_ref.current.focus()
            }
          }} 
        label="Recognition Code" name="Recognition_code" value={Recognition_code} 
        variant="outlined" size="small" onChange={(e)=>Recognition_code_set(e.target.value)} /> */}
        </Grid>


        
        </Grid>
     
     




        <Grid item xs={12} sm={12}>
        <TableContainer >
      <Table className={classes.table} size="small" aria-label="a dense table" style={{marginTop: '20px'}}>
        <TableHead>
              <TableRow>
              <TableCell align="left"   style={{width:'1%'}}>SL</TableCell>
              <TableCell align="left"   style={{width:'20%'}}>descriptionription</TableCell>
              <TableCell align="right"  style={{width:'10%'}}>Recognition Amount</TableCell>
              <TableCell align="right"  style={{width:'10%'}}>Remark</TableCell>
              <TableCell align="right"  style={{width:'10%'}}>Actions</TableCell>
            </TableRow>
        </TableHead>
        <TableBody>
              {
                recognitionCart.map((acc,sl)=>(<>
                   <TableRow key={sl} style={{background: sl == Recognition_ind_id ? '#dedede':'',  transition: '1s'}}>
                  <TableCell align="left">{sl+parseFloat(1)}</TableCell>
                  <TableCell align="left">{acc.description}</TableCell>
                  <TableCell align="right">{format(parseFloat(acc.amount).toFixed(2))}</TableCell>
                  <TableCell align="right">{acc.remark}</TableCell>
                  <TableCell align="right">
                  <EditIcon style={{cursor:'pointer',color:'#2e482e',marginLeft:'2px'}} onClick={()=>{editRecognitionTran(acc,sl)}}></ EditIcon>
                  <span style={{width:'2px'}}> </span>
                  <RemoveCircleIcon style={{cursor:'pointer',color:'#582727',marginLeft:'2px'}} onClick={()=>{removeRecognitionTran(sl)}}></ RemoveCircleIcon>
                  </TableCell>
              
                  </TableRow>
                </>))
              }

              {
                recognitionCart.length > 0 ? (<>
                <TableRow style={{background: 'rgb(249 243 243)',transition: '1s'}}>
                    <TableCell align="right" colSpan={2} style={{fontWeight:'bold'}}>Total Recognition Amount : </TableCell>
                    <TableCell align="right" style={{fontWeight:'bold'}}> {format(parseFloat(_.sumBy(recognitionCart,(tran)=>parseFloat(tran.amount))).toFixed(2))}</TableCell>
                    <TableCell align="right">----------</TableCell>
                 </TableRow>
                </>):''
                 
              }
             
         


     
        </TableBody>
      </Table>
    </TableContainer>


    <TableContainer  style={{float:'right'}}>
      <Table className={classes.table} size="small" aria-label="a dense table">
     
          <TableRow > 
             <TableCell style={{width: '325px'}}><TextareaAutosize  
             ref={narration_ref}
            
               
               onChange={(e)=>{narration_set(e.target.value)}} value={narration}  name="narration" style={{float:'left',marginTop:'20px',width: '325px'}} aria-label="Narration..." rowsMin={3} placeholder="Narration..." />
             </TableCell>

             <TableCell colSpan={2}></TableCell>

           
          
          </TableRow>
        
      </Table>
    </TableContainer>


        </Grid>



        </Grid>


      


     



        

      
  
      </Grid>


  
         <Grid item xs={12}>
  <Button style={{marginTop: '25px'}}
        variant="contained"
        color="primary"
        size="small"
        className={classes.button}
        style={{color: 'white',
          backgroundColor: '#115f5f'}}
        disabled={loadingSave}
        startIcon={<SaveIcon />}
        onClick={saveFormAction}
      >
        Save
      </Button>
  </Grid>         


     </Paper>

     {
      loadingList==true?(<b>Loading...</b>):(
        <Paper className={classes.paper} style={{marginTop:'20px'}}>
        <MUIDataTable
      title={"Recognition Entry List"}
      data={Recognitions}
      columns={columns}
      options={options}
      adjustForCheckbox={false} 
      displaySelectAll={false}
      />
      </Paper>
      )
      
     }

     
    </div>
        
    );
}


 const options = {
   filterType: 'checkbox',
 };
const useStyles = makeStyles((theme) => ({
  button: {
    margin: theme.spacing(1),
  },

root: {},
'& .MuiTextField-root': {
  margin: theme.spacing(1),
  width: '25ch',
 },
  paper: {
      padding: theme.spacing(2),
      textAlign: 'center',
      color: theme.palette.text.secondary,
  },
  pageEntryLabel:{
      color: '#7754cc',
      margin: '0px',
      padding: '0px',
      marginTop: '-11px',
      textAlign: 'left',
      marginLeft: '0px',
      marginBottom: '5px'
  },
  fullWidth:{
      width:'100%'
  },
  option: {
      fontSize: 15,
      '& > span': {
        marginRight: 10,
        fontSize: 18,
      },
    },
    plusLinkDiv:{
        position:'relative'  
  },
  plusLink:{
    margin: 0,
    padding: 0,
    marginTop: '-21px',
    fontSize: '29px',
    height: '21px',
    textAlign: 'right',
    position: 'absolute',
    right: 0,
    color: '#3e8d54'
  }
}));

const mapStateToPops = (state)=>{
      return {
        currentRoute:state.currentRouteReducer,
        authInfo:state.authInfoReducer
      }
}
export default connect(mapStateToPops,{currentRouteSet})(GroupManage);